var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAntiHarrasPolicy = function SvgAntiHarrasPolicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.824 11.015a6.2 6.2 0 0 0 .764-4.664c-.797-3.609-5.212-5.084-7.962-2.665-.218.19-.412.41-.626.629-.214-.22-.408-.439-.626-.629-2.75-2.419-7.165-.944-7.962 2.665a6.2 6.2 0 0 0 .764 4.664c1.501 2.411 3.922 4.288 6.283 5.99a2.64 2.64 0 0 0 3.082 0c2.361-1.702 4.782-3.579 6.283-5.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 7.5a3.2 3.2 0 0 0-2.5-2.5"
  })));
};
export default SvgAntiHarrasPolicy;